import React, { useEffect } from 'react';

const Tooltip = ({
  action,
  actionMessage,
  isLaunchTooltip,
  link,
  loadDelay,
  onClose,
  message,
  showTooltip,
  tooltipId,
  setShowTooltip,
}) => {
  useEffect(() => {
    if (loadDelay) {
      setTimeout(() => setShowTooltip(true), loadDelay);
    }
  }, [loadDelay, setShowTooltip]);

  return (
    showTooltip && (
      <div id={tooltipId || `tooltip_${Math.random().toString(36).slice(-5)}`} className="Tooltip">
        <div className="tooltip-container">
          <button className="close-button" onClick={onClose}></button>
          {isLaunchTooltip && <div>NEW!</div>}
          {message && <div>{message}</div>}
          {link && <div>{link}</div>}
          {actionMessage && <a onClick={action || onClose}>{actionMessage}</a>}
        </div>
      </div>
    )
  );
};

export default Tooltip;
